// src/components/OfferServiceManagement/OfferServiceTable.js
import React from "react";
import PaginationComponent from "../../../components/Pagination/PaginationComponent";
import SelectSingleComponent from "../../../components/SelectSingleComponent/SelectSingleComponent";
import { IconEdit, IconFile, IconTrash } from "../../../assets/icons";
import { toast } from "react-toastify";
import { OfferServiceService } from "../../../services/offerServiceService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const OfferServiceTable = ({
  offerServices,
  columns,
  onPageChange,
  totalRecord,
  currentPage,
  onPageSizeChange,
  pageSize,
  refetchData,
  setEditingOfferService,
  setIsModalVisible,
  selectedOfferServices,
  setSelectedOfferServices,
}) => {
  const navigate = useNavigate();

  const handleDelete = async (offerServiceId) => {
    try {
      const confirmDelete = window.confirm(
        "Bạn có chắc chắn muốn xóa ưu đãi/dịch vụ này?"
      );
      if (!confirmDelete) return;

      const response = await OfferServiceService.deleteOfferService(
        offerServiceId
      );
      if (response.Status === 200) {
        toast.success("ưu đãi/dịch vụ đã được xóa thành công!");
        // Gọi lại API để cập nhật danh sách ưu đãi/dịch vụ
        onPageChange?.(currentPage);
        refetchData?.();
      } else {
        toast.error("Xóa ưu đãi/dịch vụ thất bại!");
      }
    } catch (error) {
      console.error("Error deleting offerService:", error);
      toast.error("Có lỗi xảy ra khi xóa ưu đãi/dịch vụ!");
    }
  };

  const handleEdit = async (offerServiceSlug) => {
    try {
      const response = await OfferServiceService.getOfferServiceDetail(
        offerServiceSlug
      );
      if (!response.Data) {
        toast.error("Có lỗi khi cập nhật ưu đãi/dịch vụ!");
        return;
      }
      setEditingOfferService(response.Data); // Truyền vào form
      setIsModalVisible(true); // Hiển thị form
    } catch (error) {
      toast.error("Có lỗi khi cập nhật ưu đãi/dịch vụ!");
      console.error(error);
    }
  };

  const renderTableHeaders = () => {
    return columns.map(
      (column) =>
        column.isDisplay && <th key={column.key}>{column.displayName}</th>
    );
  };

  const renderTableRows = () => {
    return offerServices.map((offerService, index) => (
      <tr key={offerService.id}>
        <td className="w-16">
          <input
            type="checkbox"
            className="cursor-pointer"
            checked={selectedOfferServices.includes(offerService.id)}
            onChange={() => handleCheckboxChange(offerService.id)}
          />
        </td>
        <td>{(currentPage - 1) * pageSize + index + 1}</td>
        {columns.map((column) =>
          column.isDisplay ? (
            <td key={column.key} className={column.key === "images" && "w-36"}>
              {column.key === "images" &&
              offerService[column.key].length > 0 ? (
                <img
                  src={offerService[column.key][0]}
                  alt={offerService.name || "OfferService Image"}
                  className="w-16 h-16 object-cover rounded-md"
                />
              ) : column.key === "applyStartDate" ||
                column.key === "applyEndDate" ? (
                dayjs(offerService[column.key]).format("DD-MM-YYYY HH:mm:ss")
              ) : (
                offerService[column.key]
              )}
            </td>
          ) : null
        )}
        <td>
          <div className="flex gap-2">
            <button
              className="bg-primaryColor rounded-md p-1"
              onClick={() => handleEdit(offerService.slug)}
              data-tooltip={"Chỉnh sửa"}
            >
              <IconEdit className="stroke-white w-6 h-6" />
            </button>
            <button
              className="bg-red-500 rounded-md p-1"
              onClick={() => handleDelete(offerService.id)}
              data-tooltip={"Xoá"}
            >
              <IconTrash className="stroke-white w-6 h-6" />
            </button>
            <button
              className="bg-green-500 rounded-md p-1"
              onClick={() => navigate(`/services-offers/${offerService.slug}`)}
              data-tooltip={"Xem trang ưu đãi/dịch vụ"}
            >
              <IconFile className="stroke-white w-6 h-6" />
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  const handleCheckboxChange = (offerServiceId) => {
    setSelectedOfferServices(
      (prev) =>
        prev.includes(offerServiceId)
          ? prev.filter((id) => id !== offerServiceId) // Bỏ khỏi danh sách nếu đã chọn
          : [...prev, offerServiceId] // Thêm vào danh sách nếu chưa chọn
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedOfferServices(
        offerServices.map((offerService) => offerService.id)
      ); // Chọn tất cả
    } else {
      setSelectedOfferServices([]); // Bỏ chọn tất cả
    }
  };

  return (
    <div>
      <table>
        <thead>
          <tr>
            <th className="w-16 text-center">
              <input
                type="checkbox"
                className="cursor-pointer"
                onChange={(e) => handleSelectAll(e.target.checked)}
                checked={
                  selectedOfferServices.length > 0 &&
                  selectedOfferServices.length === offerServices.length
                }
              />
            </th>
            <th className="w-16">STT</th>
            {renderTableHeaders()}
            <th className="w-32">Hành động</th>
          </tr>
        </thead>
        <tbody>{renderTableRows()}</tbody>
      </table>
      <div className="flex justify-between">
        <div className="flex gap-2 items-center">
          <span>Số dòng mỗi trang:</span>
          <SelectSingleComponent
            options={[
              { value: 10, label: 10 },
              { value: 20, label: 20 },
              { value: 50, label: 50 },
            ]}
            onChange={() => onPageSizeChange?.()}
            selectedOption={pageSize}
          />
        </div>
        {/* {renderPagination()} */}
        <PaginationComponent
          currentPage={currentPage}
          pageSize={pageSize}
          total={totalRecord}
          onChange={(page) => onPageChange?.(page)}
        />
      </div>
    </div>
  );
};

export default OfferServiceTable;
